import styled, { css } from 'styled-components'
import { TextArea } from '@blueprintjs/core'
import Button from '../Button'

export const UserName = styled.div`
  font-family: 'Noto Sans TC', Helvetica, Arial, 'Helvetica Neue',
      '微軟正黑體', 'Microsoft JhengHei', PMingLiU, sans-serif;font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: 0.2px;
  color: #585858;
`

export const Datetime = styled.div`
  color: #cdcdcd;
  font-size:14px;
`

export const Text = styled.p`
  color: #9b9b9b;
  font-family: 'Noto Sans TC', Helvetica, Arial, 'Helvetica Neue',
      '微軟正黑體', 'Microsoft JhengHei', PMingLiU, sans-serif;font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.2px;
  word-break: break-all;
`

export const IconContainer = styled.span`
  display: inline-block;
  height: 2.7rem;
  width: 3rem;
  vertical-align: center;
  margin-top: 0.5rem;
`

export const TextEdit = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Respond = styled.div`
  color: #ff730e;
  font-weight: 500;
  &:hover {
    cursor: pointer;
  }
`
export const Cancel = styled(Button)`
  background-color: white;
  color: #7b7b7b;
  padding: 1rem 2rem;
  border: solid 1px #cdcdcd;
  margin-right: 1.2rem;
`

export const Confirm = styled(Button)`
  padding: 1rem 2rem;
  margin-right: 2.4rem;
`

export const CommentText = styled(TextArea)`
  && {
    width: 100%;
    border-radius: 4px;
    border: solid 1px #979797;
    height: 120px;
    max-width: 100%;
    padding: 8px;
    font-size: 16px;
    letter-spacing: 0.08rem;
    color: #7b7b7b;
    outline:none;
    &:focus {
      outline:none !important;
    }
  }
`

export const CommentBtn = styled(Button)`
  margin-top: 1.6rem;
  padding: 1rem 5.6rem;
  line-height: 2.4rem;
  margin-bottom: 2rem;
`

export const CommentTextSm = styled(CommentText)`
  width: 100%;
  height: 8rem;
`
export const CommentTextXs = styled(CommentText)`
  height: 80px;
  width: 100%;
`

export const ConfirmXs = styled.button`
  color: #ff730e;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.08rem;
  border: 0;
  position: absolute;
  bottom: 12px;
  right: 8px;
  background-color: rgba(0, 0, 0, 0);
`

export const CancelXs = styled.button`
  color: #9b9b9b;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.08rem;
  border: 0;
  position: absolute;
  bottom: 12px;
  right: 48px;
  background-color: rgba(0, 0, 0, 0);
`

export const CommentEdit = styled.div`
  padding: 4px auto;
`



// WEBPACK FOOTER //
// ./src/components/LectureComment/styles.js